import script from "./NavigationItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationItem.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationItem.vue?vue&type=style&index=0&id=01c5be13&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c5be13"]])

export default __exports__